import React, { memo } from 'react';
import { CTAButton } from './ui/CTAButton';
export function ProductSection() {
  return <section className="w-full bg-gray-50 py-16" data-id="element-242">
      <div className="max-w-3xl mx-auto px-4" data-id="element-243">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-gray-900" data-id="element-244">
          📚 ¿Qué incluye exactamente el Mega Pack?
        </h2>

        <div className="space-y-8" data-id="element-245">
          {/* Tomo 1 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-246">
            <h3 className="text-2xl font-bold text-blue-600 mb-4 flex items-center gap-2" data-id="element-247">
              <span data-id="element-248">📘</span> Tomo 1 — Motricidad Fina
            </h3>
            <p className="text-gray-700 mb-4 text-lg" data-id="element-249">
              Actividades diseñadas para fortalecer la coordinación y el control
              de los movimientos de manos y dedos.
            </p>
            <p className="font-semibold text-gray-800 mb-2" data-id="element-250">
              Incluye ejercicios como:
            </p>
            <ul className="grid grid-cols-2 md:grid-cols-3 gap-2 mb-4 text-gray-600" data-id="element-251">
              <li data-id="element-252">• trazos</li>
              <li data-id="element-253">• plastilina</li>
              <li data-id="element-254">• dactilopintura</li>
              <li data-id="element-255">• trozado</li>
              <li data-id="element-256">• recortes</li>
            </ul>
            <p className="text-sm font-medium text-gray-500 bg-gray-50 p-3 rounded-lg" data-id="element-257">
              Estas actividades ayudan a preparar a los niños para escribir,
              dibujar y manipular objetos con mayor precisión.
            </p>
          </div>

          {/* Tomo 2 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-258">
            <h3 className="text-2xl font-bold text-purple-600 mb-4 flex items-center gap-2" data-id="element-259">
              <span data-id="element-260">🧠</span> Tomo 2 — Atención y Concentración
            </h3>
            <p className="text-gray-700 mb-4 text-lg" data-id="element-261">
              Actividades que estimulan la observación y el enfoque.
            </p>
            <p className="font-semibold text-gray-800 mb-2" data-id="element-262">Incluye:</p>
            <ul className="grid grid-cols-2 gap-2 mb-4 text-gray-600" data-id="element-263">
              <li data-id="element-264">• laberintos</li>
              <li data-id="element-265">• encuentra las diferencias</li>
              <li data-id="element-266">• secuencias</li>
              <li data-id="element-267">• busca letras</li>
              <li data-id="element-268">• figuras que siguen</li>
            </ul>
            <p className="text-sm font-medium text-gray-500 bg-gray-50 p-3 rounded-lg" data-id="element-269">
              Perfecto para desarrollar la concentración y la capacidad de
              resolver pequeños desafíos.
            </p>
          </div>

          {/* Tomo 3 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-270">
            <h3 className="text-2xl font-bold text-green-600 mb-4 flex items-center gap-2" data-id="element-271">
              <span data-id="element-272">🗣</span> Tomo 3 — Vocabulario
            </h3>
            <p className="text-gray-700 mb-4 text-lg" data-id="element-273">
              Actividades que ayudan a ampliar el lenguaje y el conocimiento del
              mundo.
            </p>
            <p className="font-semibold text-gray-800 mb-2" data-id="element-274">
              Incluye temas como:
            </p>
            <ul className="grid grid-cols-2 gap-2 mb-4 text-gray-600" data-id="element-275">
              <li data-id="element-276">• animales</li>
              <li data-id="element-277">• los sentidos</li>
              <li data-id="element-278">• partes del cuerpo</li>
              <li data-id="element-279">• emociones</li>
              <li data-id="element-280">• cuentos de estimulación</li>
            </ul>
            <p className="text-sm font-medium text-gray-500 bg-gray-50 p-3 rounded-lg" data-id="element-281">
              Ideal para fortalecer la comunicación y el desarrollo del
              lenguaje.
            </p>
          </div>

          {/* Tomo 4 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-282">
            <h3 className="text-2xl font-bold text-orange-600 mb-4 flex items-center gap-2" data-id="element-283">
              <span data-id="element-284">🔎</span> Tomo 4 — Razonamiento
            </h3>
            <p className="text-gray-700 mb-4 text-lg" data-id="element-285">
              Actividades diseñadas para estimular el pensamiento lógico.
            </p>
            <p className="font-semibold text-gray-800 mb-2" data-id="element-286">Incluye:</p>
            <ul className="grid grid-cols-2 md:grid-cols-3 gap-2 mb-4 text-gray-600" data-id="element-287">
              <li data-id="element-288">• relaciones</li>
              <li data-id="element-289">• conecta los puntos</li>
              <li data-id="element-290">• memoria</li>
              <li data-id="element-291">• números</li>
              <li data-id="element-292">• pensamiento lógico</li>
              <li data-id="element-293">• sumas simples</li>
              <li data-id="element-294">• coloreo numérico</li>
            </ul>
            <p className="text-sm font-medium text-gray-500 bg-gray-50 p-3 rounded-lg" data-id="element-295">
              Los niños aprenden a observar, analizar y resolver pequeños
              problemas.
            </p>
          </div>

          {/* Tomo 5 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-296">
            <h3 className="text-2xl font-bold text-red-500 mb-4 flex items-center gap-2" data-id="element-297">
              <span data-id="element-298">✏️</span> Tomo 5 — Lectoescritura
            </h3>
            <p className="text-gray-700 mb-4 text-lg" data-id="element-299">
              Actividades que introducen a los niños en el mundo de las letras.
            </p>
            <p className="font-semibold text-gray-800 mb-2" data-id="element-300">Incluye:</p>
            <ul className="grid grid-cols-2 md:grid-cols-3 gap-2 mb-4 text-gray-600" data-id="element-301">
              <li data-id="element-302">• letras y vocales</li>
              <li data-id="element-303">• silabario</li>
              <li data-id="element-304">• conciencia silábica</li>
              <li data-id="element-305">• sopa de letras</li>
              <li data-id="element-306">• completar vocales</li>
              <li data-id="element-307">• memoria verbal</li>
            </ul>
            <p className="text-sm font-medium text-gray-500 bg-gray-50 p-3 rounded-lg" data-id="element-308">
              Perfecto para preparar a los niños para la lectura y la escritura.
            </p>
          </div>
        </div>

        <div className="mt-12" data-id="element-309">
          <CTAButton data-id="element-310" />
        </div>
      </div>
    </section>;
}